import { PaywallChargesList } from "@circle-react-shared/Paywalls/PaywallChargesList";
import { PaywallChargesListContextProvider } from "@circle-react-shared/Paywalls/PaywallChargesList/PaywallChargesListContextProvider";
import { EmptyPage } from "../../Filters/EmptyPage";
import { usePaywallChargesList } from "./hooks/usePaywallChargesList";

export interface ChargesListProps {
  activeFilterTab: string;
  chargesData: any;
  refetchAllCharges: () => void;
}

export const ChargesList = ({
  chargesData,
  activeFilterTab,
  refetchAllCharges,
}: ChargesListProps) => {
  const { onClickPagination, columnsToRender } = usePaywallChargesList({
    chargesData,
  });

  if (
    chargesData.hasFilters &&
    chargesData.totalCharges === 0 &&
    !chargesData.isLoadingCharges
  ) {
    return <EmptyPage />;
  }

  return (
    <PaywallChargesListContextProvider
      shouldOpenAdminMemberEdit
      refetchAllCharges={refetchAllCharges}
    >
      <PaywallChargesList
        wrapperClassName="px-6 lg:px-9"
        key={activeFilterTab}
        columnsToRender={columnsToRender}
        chargesData={chargesData}
        onClickPagination={onClickPagination}
      />
    </PaywallChargesListContextProvider>
  );
};
